export default {
  Logs: {
    Menu: 'Logs',
    Bills: {
      TableTitle: 'لاگ فاکتورها',
      User: 'اپراتور',
      Bill: 'فاکتور',
      Description: 'توضیحات',
      IsPublic: 'ثبت توسط اپراتور',
      LastMessage: 'آخرین پیام',
      OperatorSaved: 'توسط _operator_ در تاریخ',
    },
    webhookTypes: {
      InfoProduct: 'اطلاعات محصول',
      InfoCategory: 'اطلاعات دسته بندی',
      PlanProduct: 'محصولات',
      Order: 'سفارشات',
      Takeout: 'برداشت',
      Refund: 'استرداد',
      Ticket: 'تیکت',
    },
  },
}
